import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Table } from "react-bootstrap";
import Select from "react-select";

import MultiSelect from "../Form/MultiSelect/MultiSelect";
import { customInputStyle, customStyles } from "../ReactSelect/NoOptions.styles";
import { decimalValidateNew, formatMilesDecimalNew } from "@/services/Utils";
import { ESTATE_PARENT_PLURAL, ESTATE_PLURAL } from "@/services/estateLabels";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";

import { CropInput, CustomSingleValue } from "../Form/Inputs/Crop/CropInput";

const BusinessCenterSectorTable = ({ data, handleInputChange, addRow, removeRow, lockBtn = false, showBusinessCenter = true, crops, isImplementation }) => {
	const { customer } = useSelector((state) => state.auth.user);

	const [localCrops, setLocalCrops] = useState([]);

	useEffect(() => {
		if (localCrops.length === 0) {
			setLocalCrops(crops);
		}
		// eslint-disable-next-line
	}, [crops]);

	return (
		<>
			<Table hover>
				<thead>
					<tr>
						<th className="border-0" style={{ width: "15%" }}>
							{customer.use_sectors ? "Sector" : "Centro de Costo"} <small className="text-danger">*</small>
						</th>
						{customer.use_sectors ? (
							!!showBusinessCenter && (
								<th className="border-0" style={{ width: "15%" }}>
									Centro de Costo
									<small className="text-danger">*</small>
								</th>
							)
						) : (
							<>
								<th className="border-0" style={{ width: "15%" }}>
									{ESTATE_PARENT_PLURAL} <small className="text-danger">*</small>
								</th>
								<th className="border-0" style={{ width: "15%" }}>
									{ESTATE_PLURAL} <small className="text-danger">*</small>
								</th>
							</>
						)}
						<th className="border-0" style={{ width: "5%" }}>
							Superficie (ha) <small className="text-danger">*</small>
						</th>
						<th className="border-0" style={{ width: "15%" }}>
							Especie <small className="text-danger">*</small>
						</th>
						<th className="border-0" style={{ width: "15%" }}>
							Variedad <small className="text-danger">*</small>
						</th>
						<th className="border-0" style={{ width: "10%" }}>
							Fecha Probable de Cosecha
						</th>
						<th className="border-0" style={{ width: "5%" }}>
							Acciones
						</th>
					</tr>
				</thead>
				<tbody>
					{data.businessCenters.length === 0 ? (
						<tr>
							<td colSpan={6} className="text-center">
								No hay {customer.use_sectors ? "sectores" : "centros de costo"} agregados
							</td>
						</tr>
					) : (
						data.businessCenters.map((businessCenter, index) => {
							let optionsEstatesParents = showBusinessCenter ? [...data.estateParents] : [];
							const optionsEstates = data.estates.filter((estate) => estate.estate_parent_id === businessCenter.estateParents?.value);

							return (
								<tr key={index}>
									<td className="position-relative table-td-implementation input-text">
										<input
											type="text"
											className={`form-control ${businessCenter.name ? "" : "is-invalid"}`}
											placeholder={customer.use_sectors ? "Nombre del sector" : "Nombre de centro de costo"}
											style={customInputStyle}
											required
											value={businessCenter.name || ""}
											onChange={(e) => handleInputChange(index, "name", e.target.value)}
										/>
										{businessCenter.isNew && (
											<div className="diagonal-badge">
												<span className="badge badge-info">Nuevo</span>
											</div>
										)}
									</td>
									{customer.use_sectors ? (
										!!showBusinessCenter && (
											<td className="table-td-implementation input-text">
												<Select
													key={`business_center_parent_selector_${index}`}
													options={data.businessCenterParents}
													onChange={(e) => handleInputChange(index, "businessCenterParent", e)}
													value={businessCenter.businessCenterParent ? businessCenter.businessCenterParent : []}
													isSelectAll={true}
													menuPlacement={"bottom"}
													placeholder={"Seleccionar..."}
													isClearable={false}
													styles={{
														placeholder: (provided) => ({
															...provided,
															fontSize: "12px",
														}),
													}}
												/>
											</td>
										)
									) : (
										<>
											<td className="table-td-implementation">
												<Select
													key={`estate_parent_selector_${index}`}
													options={optionsEstatesParents}
													onChange={(e) => handleInputChange(index, "estateParents", e)}
													value={businessCenter.estateParents ? businessCenter.estateParents : []}
													isSelectAll={true}
													menuPlacement={"bottom"}
													placeholder={"Selecciona campos"}
													isClearable={false}
													styles={{
														placeholder: (provided) => ({
															...provided,
															fontSize: "12px",
														}),
													}}
												/>
											</td>
											<td className="table-td-implementation">
												<MultiSelect
													key={`estate_selector_${index}`}
													options={optionsEstates}
													onChange={(e) => handleInputChange(index, "estates", e)}
													value={businessCenter.estates ? businessCenter.estates : []}
													isSelectAll={true}
													menuPlacement={"bottom"}
													placeholder={"Selecciona bodegas"}
													isClearable={false}
													styles={{
														placeholder: (provided) => ({
															...provided,
															fontSize: "12px",
														}),
													}}
												/>
											</td>
										</>
									)}
									<td className="table-td-implementation input-text">
										<input
											type="text"
											className={`form-control text-right ${businessCenter.area ? "" : "is-invalid"}`}
											placeholder="(ha)"
											style={customInputStyle}
											required
											value={businessCenter.area ? formatMilesDecimalNew(businessCenter.area) : ""}
											onChange={(e) => {
												const value = String(e.target.value).replaceAll(".", "");
												handleInputChange(index, "area", value);
											}}
											onKeyDown={decimalValidateNew}
										/>
									</td>
									<td className="table-td-implementation input-text">
										{isImplementation ? (
											<input
												type="text"
												className="form-control"
												placeholder="Nombre de especie"
												style={customInputStyle}
												value={businessCenter.specie || ""}
												onChange={(e) => {
													handleInputChange(index, "specie", e.target.value);
												}}
											/>
										) : (
											<Select
												value={localCrops && localCrops.find((crop) => String(crop.value) === String(businessCenter.specie))}
												placeholder={<div>Seleccione</div>}
												options={localCrops ? localCrops : []}
												styles={customStyles}
												onChange={(value) => {
													handleInputChange(index, "specie", value ? value.value : "");
													handleInputChange(index, "variety", "");
													handleInputChange(index, "crop_detail_id", "");
												}}
												components={{ Option: CropInput, SingleValue: CustomSingleValue }}
												isClearable
											/>
										)}
									</td>
									<td className="table-td-implementation input-text">
										{isImplementation ? (
											<input
												type="text"
												className="form-control"
												placeholder="Nombre de variedad"
												style={customInputStyle}
												value={businessCenter.variety || ""}
												onChange={(e) => {
													handleInputChange(index, "variety", e.target.value);
												}}
											/>
										) : (
											<Select
												value={
													businessCenter.specie && businessCenter.crop_detail_id
														? localCrops
																.find((crop) => String(crop.value) === String(businessCenter.specie))
																?.varieties?.find((v) => String(v.value) === String(businessCenter.crop_detail_id)) || null
														: null
												}
												placeholder={<div>Seleccione</div>}
												options={
													businessCenter.specie
														? localCrops.find((crop) => String(crop.value) === String(businessCenter.specie))?.varieties || []
														: []
												}
												styles={customStyles}
												isDisabled={!businessCenter.specie}
												onChange={(value) => {
													handleInputChange(index, "variety", value ? value.label : "");
													handleInputChange(index, "crop_detail_id", value ? value.value : "");
												}}
												isClearable
											/>
										)}
									</td>
									<td className="table-td-implementation input-text">
										<input
											type="date"
											className={`form-control`}
											placeholder="Fecha de cosecha"
											style={customInputStyle}
											value={businessCenter.harvest_date ?? ""}
											onChange={(e) => handleInputChange(index, "harvest_date", e.target.value)}
										/>
									</td>
									<td className="table-td-implementation input-text text-center">
										<div className="btn-group">
											<RemoveSvg
												style={{ cursor: "pointer", width: "1.5em", height: "1.5em" }}
												onClick={() => removeRow(index, businessCenter.isNew)}
											/>
										</div>
									</td>
								</tr>
							);
						})
					)}
					<tr>
						<td className="border-0">
							<button
								className="btn bg-agro-outline-color btn-block tr-btn"
								onClick={addRow}
								style={{ height: "30px", fontSize: "12px", width: "200px" }}
								disabled={lockBtn}
							>
								<i className="ti-plus"></i> Agregar
							</button>
						</td>
					</tr>
				</tbody>
			</Table>
		</>
	);
};

export default BusinessCenterSectorTable;
